import script from "./ClientDeviceMonitorSystemMonitorAlarm.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientDeviceMonitorSystemMonitorAlarm.vue?vue&type=script&setup=true&lang=js"

import "./ClientDeviceMonitorSystemMonitorAlarm.vue?vue&type=style&index=0&id=cd6510b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd6510b2"]])

export default __exports__